import * as Auth from './auth'
import axios from 'axios'

// axios.defaults.baseURL = 'https://stg-api.paradigmfitnessindonesia.com/'
axios.defaults.baseURL = process.env.VUE_APP_API_URL

axios.defaults.headers.common['Accept-Language'] = 'all'
axios.defaults.headers.common['X-Accept-Language'] = 'all'
axios.defaults.headers.common['X-Paradigm-Session'] = 'DEFAULT'

if (Auth.Session.get().paradigm_token) {
  axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
}

// if (Auth.Session.get().paradigm_cached_selected_menu) {
//   axios.defaults.headers.common['X-Menu-Id'] = Auth.Session.get().paradigm_cached_selected_menu
// }

if (Auth.Session.get().paradigm_user_id) {
  axios.defaults.headers.common['X-User-Id'] = Auth.Session.get().paradigm_user_id
  axios.defaults.headers.common['X-Tuser-Id'] = Auth.Session.get().paradigm_user_id
}

if (Auth.Session.get().paradigm_role) {
  axios.defaults.headers.common['X-Role-Id'] = Auth.Session.get().paradigm_role
}

if (Auth.Session.get().paradigm_id) {
  axios.defaults.headers.common['X-Paradigm-Id'] = Auth.Session.get().paradigm_id
}

if (Auth.Session.get().paradigm_session) {
  axios.defaults.headers.common['X-Paradigm-Session'] = Auth.Session.get().paradigm_session
}

if (Auth.Session.get().paradigm_branch_id) {
  axios.defaults.headers.common['X-Paradigm-Branch-Id'] = Auth.Session.get().paradigm_branch_id
}
// console.log(Auth.Session.get().paradigm_token)

export {
  Auth
}
